module.exports = __webpack_public_path__ + "static/media/cancertypes_icon.a8907343.svg";